import styled from 'styled-components';

export const ImgOverlay = styled.div.attrs({
  className: 'img-overlay',
})`
  position: absolute;
  z-index: 100;
`;
